import {
  Coordinates,
  CurrencyInfo,
  GeographyPointLocation,
  IBuilding,
  ICafeListItemViewModel,
  MealPeriod,
  OnlineAvailabilityCapability,
} from "@dining/api-client";
import { v4 as uuidv4 } from "uuid";
import { DefaultConstant } from "./../../common/commonConstants";
import { UpdateCafeFormFields } from "./UpdateCafeForm";

export type ICafeViewModel = ICafeListItemViewModel & {
  currencyInfo: CurrencyInfo;
  vendorId?: string;
};

export const defaultUpdateCafeFormFields: UpdateCafeFormFields = {
  cafeRegion: "",
  cafeLocation: "",
  cafeName: "",
  currencyName: "",
  currencySymbol: "",
  cafeDisclaimer: "",
  cafeCountry: "",
  mealPeriods: [],
  location: new GeographyPointLocation(),
};

export const mapUpdateCafeInputToCafe = (
  inputForm: UpdateCafeFormFields,
  selectedCafe?: ICafeListItemViewModel,
  selectedBuilding?: IBuilding,
): ICafeViewModel => {
  const mealPeriods = (inputForm.mealPeriods ?? []).map((period) =>
    MealPeriod.fromJS(
      Object.assign({}, period, {
        startsOn: new Date(
          Date.UTC(1, 0, 1, Number(period.startsOn?.split(":")[0]), Number(period.startsOn?.split(":")[1])),
        ).toISOString(),
        endsOn: new Date(
          Date.UTC(1, 0, 1, Number(period.endsOn?.split(":")[0]), Number(period.endsOn?.split(":")[1])),
        ).toISOString(),
      }),
    ),
  );
  if (selectedCafe !== undefined) {
    return {
      ...selectedCafe,
      buildingId: selectedBuilding?.id || "0",
      buildingName: selectedBuilding?.name || "",
      currencyInfo: CurrencyInfo.fromJS({
        currencyName: inputForm.currencyName,
        currencySymbol: inputForm.currencySymbol,
      }),
      legacyBuildingId: selectedBuilding?.buildingId || 0,
      location: GeographyPointLocation.fromJS({
        coordinates:
          inputForm?.location?.coordinates.length > 1
            ? inputForm.location.coordinates
            : selectedBuilding?.location.coordinates,
        type: "Point",
      }),
      name: inputForm.cafeName,
      regionId: inputForm.cafeRegion,
      vendorId: DefaultConstant.MICROSOFT,
      currencyName: inputForm.currencyName,
      currencySymbol: inputForm.currencySymbol,
      disclaimer: inputForm.cafeDisclaimer,
      mealPeriods,
    };
  } else {
    return {
      id: uuidv4(),
      buildingId: selectedBuilding?.id || "0",
      buildingName: selectedBuilding?.name || "",
      currencyInfo: CurrencyInfo.fromJS({
        currencyName: inputForm.currencyName,
        currencySymbol: inputForm.currencySymbol,
      }),
      legacyBuildingId: selectedBuilding?.buildingId || 0,
      location: GeographyPointLocation.fromJS({
        coordinates:
          inputForm?.location?.coordinates.length > 1
            ? inputForm.location.coordinates
            : selectedBuilding?.location.coordinates,
        type: "Point",
      }),
      cafeId: 0,
      name: inputForm.cafeName,
      disclaimer: inputForm.cafeDisclaimer,
      serviceHours: "",
      vendorId: DefaultConstant.MICROSOFT,
      timestamp: new Date().toUTCString(),
      regionId: inputForm.cafeRegion,
      mealPeriods,
      coordinates: new Coordinates(),
      onlineAvailabilityCapability: OnlineAvailabilityCapability.Capable,
    };
  }
};
